<template>
  <div id="app">
    <main class="content">
      <!-- Tambah konten di sini -->
    </main>
    
    <footer class="footer px-4">
      <b-row align-v="center" class="justify-content-lg-between">
        <b-col lg="6">
          <div class="copyright text-center text-lg-left text-muted">
            © {{ year }} <a href="https://www.creative-tim.com" class="font-weight-bold ml-1" target="_blank">Jabatan Perkhidmatan Awam</a>
          </div>
        </b-col>
      </b-row>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
}

#app {
  display: flex;
  flex-direction: column;
}

.content {
  flex: 11; /* Memastikan konten mengambil ruang yang tersedia */
}

.footer {
    margin-top: auto; /* Memastikan footer berada di bawah */
    padding: 20px 0; /* Menambah padding jika perlu */
    background-color: #f8f9fa; /* Warna latar belakang untuk footer */
}
</style>
